"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcFloatMenuBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var helpers_2 = require("../../../common/helpers");
var bc_float_menu_constants_1 = require("./bc-float-menu-constants");
var bc_float_menu_constants_2 = require("./bc-float-menu-constants");
var bc_float_menu_constants_3 = require("./bc-float-menu-constants");
var bc_float_menu_constants_4 = require("./bc-float-menu-constants");
var bc_float_menu_constants_5 = require("./bc-float-menu-constants");
var bc_float_menu_constants_6 = require("./bc-float-menu-constants");
var bc_float_menu_constants_7 = require("./bc-float-menu-constants");
var bc_float_menu_constants_8 = require("./bc-float-menu-constants");
var bc_float_menu_constants_9 = require("./bc-float-menu-constants");
var bc_float_menu_constants_10 = require("./bc-float-menu-constants");
var bc_float_menu_constants_11 = require("./bc-float-menu-constants");
var bc_float_menu_constants_12 = require("./bc-float-menu-constants");
var bc_float_menu_constants_13 = require("./bc-float-menu-constants");
var bc_float_menu_constants_14 = require("./bc-float-menu-constants");
var bc_float_menu_constants_15 = require("./bc-float-menu-constants");
var bc_float_menu_constants_16 = require("./bc-float-menu-constants");
var bc_float_menu_constants_17 = require("./bc-float-menu-constants");
var bc_float_menu_constants_18 = require("./bc-float-menu-constants");
var bc_float_menu_constants_19 = require("./bc-float-menu-constants");
var bc_float_menu_constants_20 = require("./bc-float-menu-constants");
var bc_float_menu_constants_21 = require("./bc-float-menu-constants");
var bc_float_menu_constants_22 = require("./bc-float-menu-constants");
var bc_float_menu_constants_23 = require("./bc-float-menu-constants");
var bc_float_menu_constants_24 = require("./bc-float-menu-constants");
var bc_float_menu_constants_25 = require("./bc-float-menu-constants");
var bc_float_menu_constants_26 = require("./bc-float-menu-constants");
var bc_float_menu_constants_27 = require("./bc-float-menu-constants");
var bc_float_menu_constants_28 = require("./bc-float-menu-constants");
var BcFloatMenuBehavior = (function (_super) {
    __extends(BcFloatMenuBehavior, _super);
    function BcFloatMenuBehavior() {
        var _this = _super.call(this) || this;
        _this.floatMenuContent = null;
        _this.toggleButton = null;
        _this.aElement = null;
        _this.liElement = null;
        _this.liElements = null;
        _this.inputSelectElement = null;
        _this.checkIfPositionLeft = null;
        _this.checkIfPositionRight = null;
        _this.arrowElement = null;
        return _this;
    }
    BcFloatMenuBehavior.setUpAll = function () {
        var floatMenuElements = Array.from(document.querySelectorAll("[class~='".concat(bc_float_menu_constants_28._FLOAT_MENU_CLASS, "']")));
        for (var _i = 0, floatMenuElements_1 = floatMenuElements; _i < floatMenuElements_1.length; _i++) {
            var element = floatMenuElements_1[_i];
            var bcFloatMenuBehavior = new BcFloatMenuBehavior();
            bcFloatMenuBehavior.setElement(element);
            bcFloatMenuBehavior.setUp();
        }
    };
    BcFloatMenuBehavior.prototype._setUp = function () {
        this.getElements(this.mySelf);
        this.setFloatWidht(this.mySelf);
        this.eventListenerToggleButtonCloseOrOpenFloatMenu();
        this.eventListenerWindowCloseFloatMenu();
        this.eventListenerSelectedLiElementes();
        this.validateIfCheckboxOrRadioButtons();
        this.setWidthIfParentIsInputSelect();
        this.initAccesibility();
        this.itemsArrow();
    };
    BcFloatMenuBehavior.prototype.getElements = function (mySelf) {
        this.toggleButton = mySelf.previousElementSibling;
        this.inputSelectElement = this.toggleButton;
        this.floatMenuContent = mySelf.querySelector(".".concat(bc_float_menu_constants_26._FLOAT_MENU_CONTENT_CLASS));
        this.liElement = this.floatMenuContent.querySelector(common_constants_1.BcCommonConstants.LI_TAG);
        this.checkIfPositionLeft = mySelf.querySelector(".".concat(bc_float_menu_constants_22._FLOAT_MENU_POSITION_LEFT));
        this.checkIfPositionRight = mySelf.querySelector(".".concat(bc_float_menu_constants_21._FLOAT_MENU_POSITION_RIGHT));
        this.liElements = Array.from(this.floatMenuContent.querySelectorAll(common_constants_1.BcCommonConstants.LI_TAG));
        this.arrowElement = mySelf.querySelector(".".concat(bc_float_menu_constants_5._FLOAT_MENU_ARROW));
    };
    BcFloatMenuBehavior.prototype.setFloatWidht = function (mySelf) {
        if (!this.inputSelectElement.classList.contains(bc_float_menu_constants_4.FLOAT_MENU_INPUT_SELECT_CLASS)) {
            var al = this.toggleButton.getBoundingClientRect();
            mySelf.style.width = "".concat(al.width, "px");
            if ((this.mySelf.classList.contains(bc_float_menu_constants_22._FLOAT_MENU_POSITION_LEFT) || this.mySelf.classList.contains(bc_float_menu_constants_21._FLOAT_MENU_POSITION_RIGHT)) || this.arrowElement !== null) {
                mySelf.style.height = "".concat(al.height, "px");
            }
        }
    };
    BcFloatMenuBehavior.prototype.eventListenerToggleButtonCloseOrOpenFloatMenu = function () {
        var _this = this;
        this.toggleButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.toggleDropdown();
        });
    };
    BcFloatMenuBehavior.prototype.eventListenerWindowCloseFloatMenu = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            var isToggleElement = event.target.className.includes(bc_float_menu_constants_16._FLOAT_MENU_TOGGLE_CLASS);
            var isMainElement = event.target.className.includes(bc_float_menu_constants_25._FLOAT_MENU_OPTION_CLASS);
            var checkbox = event.target.className.includes(bc_float_menu_constants_15._FLOAT_MENU_CHECKBOX_CLASS);
            if (_this.floatMenuActive && !isToggleElement && !isMainElement && !checkbox) {
                _this.closeDropdown();
            }
        });
    };
    BcFloatMenuBehavior.prototype.deleteSelectedItem = function (item) {
        var _a, _b, _c;
        var aSelected = item.querySelector(bc_float_menu_constants_1.FLOAT_MENU_A_TAG_ELEMENT);
        if (((_b = (_a = aSelected.nextElementSibling) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.innerHTML) === 'ok') {
            aSelected.nextElementSibling.nextElementSibling.remove();
        }
        else {
            (_c = aSelected.nextElementSibling) === null || _c === void 0 ? void 0 : _c.remove();
        }
        if (this.checkSiblingElementEM(aSelected)) {
            aSelected.nextElementSibling.classList.remove(common_constants_1.BcCommonConstants.INVISIBLE_CLASS);
        }
    };
    BcFloatMenuBehavior.prototype.checkIfSelectedItems = function (ilElements) {
        for (var _i = 0, ilElements_1 = ilElements; _i < ilElements_1.length; _i++) {
            var item = ilElements_1[_i];
            if (this.checkIfCheckbox(item)) {
                var isIt = item;
                if (isIt.className.includes(bc_float_menu_constants_17._FLOAT_MENU_SELECTED_ITEM_CLASS)) {
                    isIt.classList.remove(bc_float_menu_constants_17._FLOAT_MENU_SELECTED_ITEM_CLASS);
                    if (this.floatMenuContent.className.includes(bc_float_menu_constants_18._FLOAT_MENU_SELECTED_ICON_CLASS)) {
                        this.deleteSelectedItem(isIt);
                    }
                }
            }
        }
    };
    BcFloatMenuBehavior.prototype.selectedBehavior = function (event) {
        var floatMenuContentCurrent;
        if (this.validateIfCheckboxOrRadioButtons()) {
            floatMenuContentCurrent = event.parentElement.parentElement.parentElement.parentElement;
        }
        else {
            floatMenuContentCurrent = event.parentNode;
        }
        var ilElements = Array.from(floatMenuContentCurrent.querySelectorAll(common_constants_1.BcCommonConstants.LI_TAG));
        if (this.deleteSelectedCheckbox(event)) {
            return;
        }
        this.checkIfSelectedItems(ilElements);
        this.putSelected(event);
        if (this.checkIfCheckbox(event)) {
            this.closeDropdown();
        }
    };
    BcFloatMenuBehavior.prototype.deleteSelectedCheckbox = function (event) {
        if (!this.checkIfCheckbox(event)) {
            if (event.classList.contains(bc_float_menu_constants_17._FLOAT_MENU_SELECTED_ITEM_CLASS) === true) {
                event.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG).checked = false;
                event.classList.remove(bc_float_menu_constants_17._FLOAT_MENU_SELECTED_ITEM_CLASS);
                return true;
            }
        }
    };
    BcFloatMenuBehavior.prototype.checkIfCheckbox = function (event) {
        if (event.querySelector(".".concat(bc_float_menu_constants_15._FLOAT_MENU_CHECKBOX_CLASS)) == null) {
            return true;
        }
        else {
            return false;
        }
    };
    BcFloatMenuBehavior.prototype.putSelected = function (event) {
        var _a;
        var selected = event;
        if (this.validateIfCheckboxOrRadioButtons()) {
            selected = this.putValueToCheckboc(selected);
        }
        selected.classList.add(bc_float_menu_constants_17._FLOAT_MENU_SELECTED_ITEM_CLASS);
        this.aElement = selected.querySelector(bc_float_menu_constants_1.FLOAT_MENU_A_TAG_ELEMENT);
        if (!this.floatMenuContent.className.includes(bc_float_menu_constants_18._FLOAT_MENU_SELECTED_ICON_CLASS)) {
            return;
        }
        if (this.checkSiblingElementEM(this.aElement)) {
            (_a = this.aElement.nextElementSibling) === null || _a === void 0 ? void 0 : _a.classList.add(common_constants_1.BcCommonConstants.INVISIBLE_CLASS);
        }
        var em = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        em.innerText = 'ok';
        em.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        selected.appendChild(em);
    };
    BcFloatMenuBehavior.prototype.putValueToCheckboc = function (selected) {
        var a = selected.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
        a.checked = true;
        if (selected.classList.contains(bc_float_menu_constants_19._FLOAT_MENU_RADIO_LABEL)) {
            return ((selected.parentElement.parentElement.parentElement));
        }
        if (selected.classList.contains(bc_float_menu_constants_15._FLOAT_MENU_CHECKBOX_CLASS)) {
            return (selected.parentElement.parentElement);
        }
        else {
            return selected;
        }
    };
    BcFloatMenuBehavior.prototype.checkSiblingElementEM = function (selected) {
        if (selected.nextElementSibling !== null) {
            return selected.nextElementSibling.nodeName.toLowerCase() === common_constants_1.BcCommonConstants.EM_TAG || selected.nextElementSibling.nodeName.toLowerCase() === common_constants_1.BcCommonConstants.IMG_TAG;
        }
        else {
            return false;
        }
    };
    BcFloatMenuBehavior.prototype.eventListenerSelectedLiElementes = function () {
        var _this = this;
        for (var _i = 0, _a = this.liElements; _i < _a.length; _i++) {
            var elementLi = _a[_i];
            elementLi.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                event.preventDefault();
                _this.selectedBehavior(event.target);
            });
        }
    };
    BcFloatMenuBehavior.prototype.validateIfCheckboxOrRadioButtons = function () {
        return (this.liElement.innerHTML.includes(bc_float_menu_constants_20.FLOAT_MENU_RADIO_GROUP_CLASS) || this.liElement.innerHTML.includes(bc_float_menu_constants_15._FLOAT_MENU_CHECKBOX_CLASS));
    };
    BcFloatMenuBehavior.prototype.openDrowndown = function () {
        (0, helpers_1.replaceClass)(this.floatMenuContent, bc_float_menu_constants_26._FLOAT_MENU_CONTENT_CLASS, bc_float_menu_constants_27._FLOAT_MENU_CONTENT_ACTIVE_CLASS);
        (0, helpers_1.replaceClass)(this.arrowElement, bc_float_menu_constants_5._FLOAT_MENU_ARROW, bc_float_menu_constants_12._FLOAT_MENU_ARROW_ACTIVE);
        this.setDropdownContentPosition();
        this.floatMenuActive = true;
    };
    BcFloatMenuBehavior.prototype.closeDropdown = function () {
        (0, helpers_1.replaceClass)(this.floatMenuContent, bc_float_menu_constants_27._FLOAT_MENU_CONTENT_ACTIVE_CLASS, bc_float_menu_constants_26._FLOAT_MENU_CONTENT_CLASS);
        (0, helpers_1.replaceClass)(this.arrowElement, bc_float_menu_constants_12._FLOAT_MENU_ARROW_ACTIVE, bc_float_menu_constants_5._FLOAT_MENU_ARROW);
        this.floatMenuActive = false;
    };
    BcFloatMenuBehavior.prototype.validateDropdownIsActive = function () {
        return this.floatMenuContent.classList.contains(bc_float_menu_constants_27._FLOAT_MENU_CONTENT_ACTIVE_CLASS);
    };
    BcFloatMenuBehavior.prototype.toggleDropdown = function () {
        if (!this.validateDropdownIsActive()) {
            this.floatMenuActive = false;
        }
        if (this.floatMenuActive) {
            this.closeDropdown();
        }
        else {
            this.openDrowndown();
        }
    };
    BcFloatMenuBehavior.prototype.setWidthIfParentIsInputSelect = function () {
        if (this.inputSelectElement.classList.contains(bc_float_menu_constants_4.FLOAT_MENU_INPUT_SELECT_CLASS)) {
            var parentWidth = this.inputSelectElement.clientWidth;
            this.floatMenuContent.style.width = "".concat(parentWidth, "px");
            this.floatMenuContent.style.overflow = common_constants_1.BcCommonConstants.HIDDEN;
            this.floatMenuContent.querySelector(common_constants_1.BcCommonConstants.UL_TAG).style.maxWidth = common_constants_1.BcCommonConstants.NONE;
        }
    };
    BcFloatMenuBehavior.prototype.setDropdownContentPosition = function () {
        if (this.floatMenuActive !== null) {
            this.floatMenuPosition = this.mySelf.getBoundingClientRect();
            this.floatMenuContentPosition = this.floatMenuContent.getBoundingClientRect();
            this.windowWidth = document.documentElement.clientWidth;
            this.windowHeight = document.documentElement.clientHeight;
            var right = this.floatMenuContentPosition.right;
            var bottom = this.floatMenuContentPosition.bottom;
            var left = this.floatMenuContentPosition.left;
            this.positionDefaultFloatMenu(left, right, bottom);
            this.positionFeaturePostionFloatMenu(left, right, bottom);
            this.positionFeatureArrow(left, right, bottom);
        }
    };
    BcFloatMenuBehavior.prototype.positionFeatureArrow = function (left, right, bottom) {
        if (this.arrowElement !== null) {
            if (bottom > this.windowHeight) {
                this.mySelf.classList.add(bc_float_menu_constants_6._FLOAT_MENU_ARROW_OVERFLOW_BOTTOM);
            }
            if (right > this.windowWidth) {
                this.mySelf.classList.add(bc_float_menu_constants_8._FLOAT_MENU_ARROW_OVERFLOW_RIGHT);
            }
            if (left < 0) {
                this.mySelf.classList.add(bc_float_menu_constants_7._FLOAT_MENU_ARROW_OVERFLOW_LEFT);
            }
        }
    };
    BcFloatMenuBehavior.prototype.positionFeaturePostionFloatMenu = function (left, right, bottom) {
        if ((this.mySelf.classList.contains(bc_float_menu_constants_22._FLOAT_MENU_POSITION_LEFT) || this.mySelf.classList.contains(bc_float_menu_constants_21._FLOAT_MENU_POSITION_RIGHT))) {
            if (bottom > this.windowHeight) {
                this.mySelf.classList.add(bc_float_menu_constants_9._FLOAT_MENU_POSITION_OVERFLOW_BOTTOM);
            }
            if (right > this.windowWidth) {
                this.mySelf.classList.add(bc_float_menu_constants_11._FLOAT_MENU_POSITION_OVERFLOW_RIGHT);
            }
            if (left < 0) {
                this.mySelf.classList.add(bc_float_menu_constants_10._FLOAT_MENU_POSITION_OVERFLOW_LEFT);
            }
        }
    };
    BcFloatMenuBehavior.prototype.positionDefaultFloatMenu = function (left, right, bottom) {
        if (!(this.mySelf.classList.contains(bc_float_menu_constants_22._FLOAT_MENU_POSITION_LEFT) || this.mySelf.classList.contains(bc_float_menu_constants_21._FLOAT_MENU_POSITION_RIGHT)) && (this.arrowElement === null)) {
            if (bottom > this.windowHeight) {
                this.mySelf.classList.add(bc_float_menu_constants_24._FLOAT_MENU_OVERFLOW_BOTTOM);
            }
            if (right > this.windowWidth) {
                this.floatMenuContent.style.right = "".concat(bc_float_menu_constants_13._FLOAT_MENU_NUMBER_0, "%");
            }
            if (left < 0) {
                this.floatMenuContent.classList.add(bc_float_menu_constants_23._FLOAT_MENU_OVERFLOW_LEFT);
            }
        }
    };
    BcFloatMenuBehavior.prototype.initAccesibility = function () {
        var _this = this;
        var ulElemnet = this.floatMenuContent.querySelector(common_constants_1.BcCommonConstants.UL_TAG);
        (0, helpers_2.addFocusable)(ulElemnet, { role: bc_float_menu_constants_2.FLOAT_MENU_ROLE_MENU });
        for (var _i = 0, _a = this.liElements; _i < _a.length; _i++) {
            var iteme = _a[_i];
            var aElm = ulElemnet === null || ulElemnet === void 0 ? void 0 : ulElemnet.querySelector(bc_float_menu_constants_1.FLOAT_MENU_A_TAG_ELEMENT);
            (0, helpers_2.addFocusable)(aElm, { role: bc_float_menu_constants_3.FLOAT_MENU_ROLE_MENU_ITEM });
            (0, helpers_2.addFocusable)(iteme, { tabindex: '0', role: bc_float_menu_constants_3.FLOAT_MENU_ROLE_MENU_ITEM });
        }
        for (var _b = 0, _c = this.liElements; _b < _c.length; _b++) {
            var elementLi = _c[_b];
            elementLi.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
                if (event['key'] === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                    _this.selectedBehavior(event.target);
                    _this.closeDropdown();
                }
            });
            (0, helpers_2.addFocusable)(this.toggleButton, { tabindex: '0' });
            this.toggleButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
                if (event['key'] === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                    _this.openDrowndown();
                }
            });
            this.toggleButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
                if (event['key'] === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                    _this.closeDropdown();
                }
            });
        }
        this.floatMenuContent.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            var _liElements = Array.from(_this.floatMenuContent.querySelectorAll(common_constants_1.BcCommonConstants.LI_TAG));
            var firstItem = _liElements[bc_float_menu_constants_13._FLOAT_MENU_NUMBER_0];
            var lastIment = _liElements[_liElements.length - bc_float_menu_constants_14._FLOAT_MENU_NUMBER_1];
            if (event['key'] === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                _this.closeDropdown();
            }
            if (event['key'] === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
                firstItem.focus();
            }
            else if (event['key'] === common_constants_1.BcCommonConstants.KEY_EVENT_END) {
                lastIment.focus();
            }
        });
    };
    BcFloatMenuBehavior.prototype.itemsArrow = function () {
        var _this = this;
        var firstItem = this.liElements[0];
        var lastItem = this.liElements[this.liElements.length - bc_float_menu_constants_14._FLOAT_MENU_NUMBER_1];
        this.liElements.forEach(function (element, index) {
            element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
                if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
                    if (index == _this.liElements.length - bc_float_menu_constants_14._FLOAT_MENU_NUMBER_1) {
                        firstItem.focus();
                    }
                    else {
                        element.nextElementSibling.focus();
                    }
                }
                else if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
                    if (index == bc_float_menu_constants_13._FLOAT_MENU_NUMBER_0) {
                        lastItem.focus();
                    }
                    else {
                        element.previousElementSibling.focus();
                    }
                }
            });
        });
    };
    return BcFloatMenuBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcFloatMenuBehavior = BcFloatMenuBehavior;
